// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Tags-module--wrapper--2F8lO","tag":"Tags-module--tag--2TlEc","smallDivider":"Tags-module--small-divider--23Lli"};